import layout from 'app/store/layout';
import { buySuccess } from 'app/store/payment/actions';
import { handleErrors } from 'app/store/utils';

const { setLoader, createToast, setError } = layout.actions;

export { setLoader, handleErrors, createToast, buySuccess, setError };
